import { isAdminRole } from './projectLockLogic';
import { isProjectFinished, ProjectStatusSource } from './projectBilling';

/**
 * Darf diese Rolle das Projekt öffnen?
 *
 * BEENDET und ARCHIV sind für Mitarbeiter zu (Betreiberentscheidung
 * 06.10.2026). Die Arbeit ist vorbei; Schlussrechnung und Archiv liegen bei
 * der Buchhaltung, und die ist Sache der Administratoren. Vorher standen
 * solche Projekte gedämpft in der Liste und ließen sich weiter öffnen und
 * bearbeiten.
 *
 * Mehrere Quellen, weil die Aufrufer verschieden viel wissen: manche reichen
 * die Listenzeile herein, manche nur `{ id }` (Angebot → Projekt). Sagt
 * IRGENDEINE Quelle „beendet", ist zu — eine verspätete Zeile sperrt im
 * Zweifel einen Moment zu lange, statt ein beendetes Projekt aufzumachen.
 * Ohne jede Statusangabe bleibt offen: daraus lässt sich nichts schließen.
 */
export const istProjektGesperrtFuer = (
    role: string | null | undefined,
    ...quellen: Array<ProjectStatusSource | null | undefined>
): boolean => !isAdminRole(role) && quellen.some((q) => isProjectFinished(q));

/**
 * Trägt diese Quelle überhaupt einen Status? Wenn keine es tut, lädt der
 * Aufrufer die Zeile nach, bevor er entscheidet — sonst käme ein beendetes
 * Projekt, das (noch) nicht in der Liste steht, über `{ id }` durch.
 */
export const hatProjektStatus = (quelle: ProjectStatusSource | null | undefined): boolean =>
    !!(quelle?.status || quelle?.data?.metadata?.globalData?.status);

export const PROJEKT_GESPERRT_HINWEIS =
    'Das Projekt ist beendet. Die Buchhaltung stellt die Schlussrechnung; öffnen können es nur Administratoren und wer Projekte archivieren darf.';
